import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DxTabsComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs';
import { AccessType, AuthService, PermissionType } from '@services';
import { CreditRequestHistoryComponent } from './credit-request-history/credit-request-history.component';
import { CreditRequestDetailsComponent } from './credit-request-details/credit-request-details.component';


type TabKey = 'details' | 'history';

@Component({
    selector: 'app-credit-request',
    imports: [
        AsyncPipe,
        DxTabsComponent,
        CreditRequestDetailsComponent,
        CreditRequestHistoryComponent,
    ],
    templateUrl: './credit-request.component.html',
})
export class CreditRequestComponent {
    private route = inject(ActivatedRoute);
    private auth = inject(AuthService);

    get showDetails(): boolean {
        return this.auth.checkPermission(PermissionType.CreditRequestDetails, AccessType.ViewOnly);
    }

    get showHistory(): boolean {
        return this.auth.checkPermission(PermissionType.CreditRequestHistory, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showDetails ? 'details' : 'history';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    allTabs = [
        { key: 'details', text: 'Details', icon: 'fas fa-info-circle', permission: PermissionType.CreditRequestDetails },
        { key: 'history', text: 'History', icon: 'fas fa-history', permission: PermissionType.CreditRequestHistory },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
